<template>
	<div class="c-body">
		<div class="c-body__title">
			<h2>
				<span>Zen2Han</span>
				<button @click="toggleHelp" :class="{'-active': showHelp}">
					<c-icon :name="'question-circle'"></c-icon>
				</button>
			</h2>
		</div>
		<div class="c-help">
			<div class="c-help__inner">
				<div class="e-section">
					<p>
						文字列中の全角文字を半角文字に変換します。<br>
						変換する文字種は数字・アルファベット・空白・記号の中から任意に選択できます。<br>
						エンジニアをぜったいにころすコードをころすために生まれました。
					</p>
				</div>
			</div>
		</div>
		<div class="c-body__inner">
			<div class="e-section">
			</div>
			<div class="e-section">
				<div class="c-zen2han-app">
					<div class="e-grid -double">
						<div class="col">
							<div class="c-zen2han-app__title">
								<h3>INPUT</h3>
								<div class="e-label-list">
									<label class="e-label">
										<input type="checkbox" v-model="options.number">
										<span class="label">数字</span>
									</label>
									<label class="e-label">
										<input type="checkbox" v-model="options.alphabet">
										<span class="label">アルファベット</span>
									</label>
									<label class="e-label">
										<input type="checkbox" v-model="options.space">
										<span class="label">空白</span>
									</label>
									<label class="e-label">
										<input type="checkbox" v-model="options.symbol">
										<span class="label">記号</span>
									</label>
								</div>
							</div>
							<div class="c-zen2han-app__editor" id="zen2han-input"></div>
						</div>

						<div class="col">
							<div class="c-zen2han-app__title">
								<h3>OUTPUT</h3>
								<button class="e-button" @click="copy">クリップボードにコピー</button>
							</div>
							<div class="c-zen2han-app__editor" id="zen2han-output"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import mCommon from "../mixins/common";
import ace from "brace";
import Zen2Han from "../lib/zen2han.js";

export default {
	mixins: [
		mCommon
	],
	components: {
	},
	data (){
		return {
			options: {
				number: true,
				alphabet: true,
				space: true,
				symbol: true
			},
			inputEditor: null,
			outputEditor: null
		}
	},
	computed: {
		optionsAll (){
			return JSON.stringify($.extend(true, {}, this.options));
		}
	},
	watch: {
		optionsAll (){
			this.onChange();
		}
	},
	mounted (){
		var input, output;

		input = this.inputEditor = ace.edit("zen2han-input");
		input.setOption("fontSize", 13);
		input.on("change", this.onChange);

		output = this.outputEditor = ace.edit("zen2han-output");
		output.setOption("fontSize", 13);
		output.setOption("readOnly", true);

		// var testValue = [
		// 	"０１２３４５６７８９",
		// 	"ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ",
		// 	"ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ",
		// 	"！”＃＄％＆’（）＝〜｜｀｛＋＊｝＜＞？＿ー＾￥＠「；：」、。／",
		// 	"０１２３４５６７８９",
		// 	"ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ",
		// 	"ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ",
		// 	"！”＃＄％＆’（）＝〜｜｀｛＋＊｝＜＞？＿ー＾￥＠「；：」、。／"
		// ].join("\n");

		// input.setValue(testValue);
		// input.selection.clearSelection();
	},

	methods: {
		onChange (){
			Zen2Han.config(this.options);
			this.outputEditor.setValue(
				Zen2Han.parse(this.inputEditor.getValue())
			);
			this.outputEditor.selection.clearSelection();
		},

		copy (){
			if($.clipboard(this.outputEditor.getValue())){
				alert("クリップボードにコピーしました");
			} else {
				alert("クリップボードへのコピーに失敗しました");
			}
		}
	}
}
	
</script>


// WEBPACK FOOTER //
// zen2han.vue?c556f2d0